


















































































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import Input from '../../core/components/Input.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import VehiclesActions from './VehiclesActions.vue';
import { NormsServices } from '../../norms/api/NormsServices';
@Component({
    components: {
        Loading,
        Button,
        SimpleTable,
        SectionTitle,
        Input,
        VehiclesActions,
        MultipleSelect,
        Combobox
    }
})
export default class ModalVehicleFTP extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default: false }) visible: boolean;

    @Prop({default: {}}) vehicleProperties: object;
    @Prop({default: -1}) vehicleID: number;
    @Prop({default: null}) ftpData: object;

    ftpPaths: Array<object> = [];
    ftpState: number = -1
    modalTitle: string = 'Configurar FTP';
    settingFtp: boolean = false;

    ftpSelected: object | null = null;
    ftpSelectedRv: boolean = false;

    updateFtpSelected(value: object) {
        this.ftpSelected = value;
    }

    updateFtpSelectedRv(value: boolean) {
        this.ftpSelectedRv = value;
    }

    getFtpStateAsText(state: number): string {
        if(state === -1){
            return ' - '
        }
        return this.vehicleProperties['status_choices'][state]
    }

    getConfirmedTextClass(state: number): string {

        if(state === -1){
            return ''
        }

        let stateColors = {
            0: 'confirmed-text--confirmed',
            1: 'confirmed-text--consulting',
            2: 'confirmed-text--setting'
        }
        
        return stateColors[state]
    }

    get canSaveConfig(): boolean {
        return this.ftpSelected == null ? false : true;
    }

    @Watch('ftpData', { immediate: true, deep: true })
    onFtpData(){
        if(this.ftpData){
            this.ftpState = this.ftpData['status'];
            let paths = this.ftpData['norms'];
            let pathToPreselect = this.ftpData['path']; //string

            if(paths && paths.length > 0){
                this.ftpPaths = paths.map((path: string, index:number) => {
                    return {
                        id: index,
                        value: path
                    }
                })

                if(pathToPreselect !== null){
                    let preselected = this.ftpPaths.find((path: object) => {
                        return path['value'] === pathToPreselect
                    })
                    if(preselected){
                        this.ftpSelected = preselected;
                    }
                }
            }
        }
    }
    

    @Emit()
    closeModal() {
       
    }

    submitFtp(){
        if(this.ftpSelected){
            
            let config = {
                vehicle_id: this.vehicleID,
                path: this.ftpSelected['value']
            }
            this.settingFtp = true;
            NormsServices.saveFtpData(
                config
            ).then((response) => {
                this.$_showAddPointOfInterest(response.message)
                this.ftpState = response.ftp.status;
            }).catch((error) => {
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo configurar el FTP'
                });
                
            }).finally(() => {
                this.settingFtp = false;
                this.closeModal();
            });

        }
    }

    

    mounted() {
        this.$nextTick(() => {
            
        });
    }
}
